export default __webpack_public_path__ + "static/media/blastphylo_logo3.739882ca.svg";